<template>
  <v-container
    fluid
    class="ma-0 pa-6 pt-1"
    style="width: 100%; height: 100%; max-height: 100%;"
  >
    <v-row class="ma-0 pa-0 talktrend-stats__section-nav">
      <v-col cols="auto" class="ma-0 pa-0">
        <v-chip
          label
          class="data_breakdown_chip"
          :outlined="selected_page != 'overview'"
          @click="selected_page = 'overview'"
          color="black"
        >
          Overview
        </v-chip>
        <v-chip
          label
          class="data_breakdown_chip"
          :outlined="selected_page != 'persona'"
          @click="selected_page = 'persona'"
          color="black"
        >
          Persona
        </v-chip>
      </v-col>
    </v-row>
    <div class="talktrend-stats__section-content">
      <div v-if="selected_page == 'overview'">
        <v-row class="ma-0 pa-0">
          <v-col cols="7" class="ma-0 pa-3">
            <TalkTrendGraph
              :audience_info="viewing_aud"
              :audience_data_graph_imgs="graph_img_urls"
              :audience_data="null"
              :audience_data_tbl="audience_table_data"
              :slider_notches_tmp="Object.keys(audience_data['audience_highlights']).length"
              :starting_notch="starting_notch"
              :inner_notches="inner_notches"
              :outer_notches="outer_notches"
              :current_slider_id="curr_slider_value"
              v-on:sliderOnChange="slider_on_change"
            />
          </v-col>
          <v-col cols="5" class="ma-0 pa-3">
            <AudienceSizeWsiScatter
              :audience_highlights="audienceData['audience_highlights']"
              :slider_id="curr_slider_value"
              v-on:sliderOnChange="slider_on_change"
            />
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0" style="height: 75vh">
          <v-col cols="7" class="ma-0 pa-3">
            <TalkTrendStatTable :audienceData="audience_table_data" />
          </v-col>
          <v-col cols="5" class="ma-0 pa-3">
            <v-row class="ma-0 pa-0" v-if="hasCurrentPieCharts">
              <v-col cols="6" class="ma-0 pa-2" style="height: 30vh;">
                <AudiencePieChart
                  chart_title="Gender"
                  :chart_data="currentPieCharts.gender || []"
                  color_palette="cool"
                />
              </v-col>
              <v-col cols="6" class="ma-0 pa-2" style="height: 30vh;">
                <AudiencePieChart
                  chart_title="Age Range"
                  :chart_data="currentPieCharts.age_range || []"
                  color_palette="cool"
                />
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0" v-if="hasCurrentPyschChart">
              <v-col cols="12" class="ma-0 pa-2" style="height: calc(45vh - 56px);">
                <AudienceBarChart
                  chart_title="Psychographics"
                  :chart_data="currentPyschChart"
                  color_palette="cool"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0" v-if="hasCurrentPsychOverviewChart">
          <v-col cols="12" class="ma-0 pa-3">
            <PsychOverviewScatter :chart_data="currentPsychOverviewChart" />
          </v-col>
        </v-row>
      </div>
      <TalkTrendPersonaPage
        v-else-if="selected_page == 'persona'"
        :persona-sections="persona_sections"
      ></TalkTrendPersonaPage>
    </div>
  </v-container>
</template>

<script>
import TalkTrendGraph from "./TalkTrendStatsComponents/TalkTrendGraph.vue";
import TalkTrendStatTable from "./TalkTrendStatsComponents/TalkTrendStatTable.vue";
import AudienceBarChart from "./TalkTrendStatsComponents/TalkTrendChartComponents/AudienceBarChart.vue";
import AudiencePieChart from "./TalkTrendStatsComponents/TalkTrendChartComponents/AudiencePieChart.vue";
import AudienceSizeWsiScatter from "./TalkTrendStatsComponents/TalkTrendChartComponents/AudienceSizeWsiScatter.vue";
import PsychOverviewScatter from "./TalkTrendStatsComponents/TalkTrendChartComponents/PsychOverviewScatter.vue";
import TalkTrendPersonaPage from "./TalkTrendPersonaPage.vue";
export default {
  name: "TalkTrendStatsBasePage",
  components: {
    AudienceBarChart,
    AudiencePieChart,
    AudienceSizeWsiScatter,
    PsychOverviewScatter,
    TalkTrendPersonaPage,
    TalkTrendGraph,
    TalkTrendStatTable,
  },
  props: ["audiences", "audience_info", "audience_data", "selected_slider_id"],
  mounted() {
    this.available_audiences = [];
    for (let i = 0; i < this.audiences.length; i++) {
      if (this.audiences.audience_state !== "designing") {
        this.available_audiences.push(this.audiences);
      }
    }
    this.available_audiences = [];
    for (let i = 0; i < this.audiences.length; i++) {
      if (this.audiences[i].audience_state !== "designing") {
        let tmp = Object.assign({}, this.audiences[i]);
        if (tmp.audience_state !== "built") {
          tmp["disable"] = true;
        } else {
          tmp["disable"] = false;
        }
        this.available_audiences.push(tmp);
      }
      
    }
    this.viewing_aud = this.audience_info;
    this.audienceData = this.audience_data;
    if (this.selected_slider_id !== undefined && this.selected_slider_id !== null) {
      this.curr_slider_value = this.selected_slider_id;
    }
    this.set_starting_notch()
  },
  computed: {
    currentPieCharts: function () {
      const pieCharts = this.audienceData["pie_charts"] || {};
      const sliderKey = this.curr_slider_value.toString();

      return pieCharts[sliderKey] || pieCharts[this.curr_slider_value] || {};
    },
    hasCurrentPieCharts: function () {
      return (
        Array.isArray(this.currentPieCharts["gender"]) ||
        Array.isArray(this.currentPieCharts["age_range"])
      );
    },
    currentPyschChart: function () {
      const pyschCharts =
        this.audienceData["pysch_chart"] || this.audienceData["psych_chart"] || {};
      const sliderKey = this.curr_slider_value.toString();

      return pyschCharts[sliderKey] || pyschCharts[this.curr_slider_value] || [];
    },
    hasCurrentPyschChart: function () {
      return Array.isArray(this.currentPyschChart) && this.currentPyschChart.length > 0;
    },
    currentPsychOverviewChart: function () {
      const psychOverview =
        this.audienceData["psych_overview"] ||
        this.audienceData["psych_overview_chart"] ||
        this.audienceData["pysch_overview"] ||
        this.audienceData["pysch_overview_chart"] ||
        {};
      const sliderKey = this.curr_slider_value.toString();

      if (Array.isArray(psychOverview)) {
        return psychOverview;
      }

      if (psychOverview[sliderKey] || psychOverview[this.curr_slider_value]) {
        return psychOverview[sliderKey] || psychOverview[this.curr_slider_value];
      }

      const firstAvailableSlider = Object.keys(psychOverview)[0];
      return firstAvailableSlider ? psychOverview[firstAvailableSlider] : [];
    },
    hasCurrentPsychOverviewChart: function () {
      return (
        Array.isArray(this.currentPsychOverviewChart) &&
        this.currentPsychOverviewChart.length > 0
      );
    },
    hasAudienceHighlights: function () {
      return Object.keys(this.audienceData["audience_highlights"] || {}).length > 0;
    },
    persona_sections: function () {
      const personaData =
        this.audienceData["persona"] ||
        this.audienceData["personas"] ||
        this.audienceData["persona_sections"] ||
        this.audienceData["audience_persona"] ||
        [];

      return Array.isArray(personaData) ? personaData : [];
    },
  },
  watch: {
    audience_info: {
      handler: function (updated_audience) {
        this.viewing_aud = updated_audience;
      },
      deep: true,
    },
    audience_data: {
      handler: function (updated_audience) {
        this.audienceData = updated_audience;
      },
      deep: true,
    },
    audiences: {
      handler: function (updated) {
        this.available_audiences = [];
        for (let i = 0; i < updated.length; i++) {
          if (updated[i].audience_state !== "designing") {
            let tmp = Object.assign({}, updated[i]);
            if (updated[i].audience_state !== "built") {
              tmp["disable"] = true;
            } else {
              tmp["disable"] = false;
            }
            this.available_audiences.push(tmp);
          }
        }
      },
      deep: true,
    },
    selected_slider_id: {
      handler: function (value) {
        if (value !== undefined && value !== null && value !== this.curr_slider_value) {
          this.slider_on_change(value);
        }
      },
    },
  },
  data: () => ({
    selected_page: "overview",
    curr_slider_value: 0,
    starting_notch: 0,
    audienceData: {},
    audience_table_data: [],
    viewing_aud: {},
    graph_img_urls: [],
    available_audiences: [],

    inner_notches: 1,
    outer_notches: 1
  }),
  methods: {
    slider_on_change: function (value) {
      this.page_loading = true;
      this.curr_slider_value = value;
      let newAudienceData = [...this.audience_table_data];
      if (
        Object.keys(this.audienceData).includes("audience_statistics") &&
        Object.keys(this.audienceData["audience_statistics"]).includes(value.toString())
      ) {
        newAudienceData = this.audienceData["audience_statistics"][value.toString()];
        newAudienceData.sort(function(a, b){return a.row_id - b.row_id});
      }
      this.audience_table_data = newAudienceData;

      this.$emit("sliderOnChange", value);
      this.page_loading = false;
    },
    update_scenario: function (item) {
      this.$emit("viewing_audience", item.audience_id);
    },
    set_starting_notch() {
      const audience_stat = this.audience_data['audience_statistics']
      this.starting_notch = Object.keys(audience_stat).find(key => audience_stat[key].length == 1 && audience_stat[key][0]["type"].toUpperCase() === "P");
      console.log('num_notches')
      let inner_notches = 0;
      let outer_notches = 0;
      for(let key of Object.keys(audience_stat)){
        for(let inner_key of Object.keys(audience_stat[key])){
          if(audience_stat[key][inner_key]["type"].toUpperCase() === 'AII'){
            inner_notches += 1;
            break;
          }
          else if(audience_stat[key][inner_key]["type"].toUpperCase() === 'AIE'){
            outer_notches += 1;
            break;
          }
        }
        this.inner_notches = inner_notches;
        this.outer_notches = outer_notches;
        console.log(this.inner_notches)
        console.log(this.outer_notches)
      }
      if (this.selected_slider_id !== undefined && this.selected_slider_id !== null) {
        this.curr_slider_value = this.selected_slider_id;
        this.slider_on_change(this.selected_slider_id);
      } else if (this.starting_notch !== undefined && this.starting_notch !== null) {
        this.slider_on_change(this.starting_notch);
      }
    }
  },
};
</script>

<style>
.viewing_audience_title {
  font-family: "Poppins";
  font-weight: 600;
  font-size: 1.2em;
}

.talktrend-stats__section-nav {
  background: #ffffff;
  min-height: 42px;
  position: sticky;
  top: 0;
  z-index: 3;
}

.talktrend-stats__section-content {
  min-height: calc(100% - 42px);
}

/* .data_breakdown_chip {
  font-family: "Poppins";
  font-weight: 600;
  justify-content: center;
  margin-left: 1px;
  margin-right: 5px;
  min-width: 110px;
} */
</style>
